module.exports = __webpack_public_path__ + "img/end_tip.b12be662.png";